import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import "./NavbarMenu.css";

function NavbarMenu(props) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <Navbar color="light" light expand="md" fixed="top">
        <NavbarBrand href="/">
        <img
            alt="logo"
            src="/main-logo.png"
            style={{
              height: 40,
              width: "auto"
            }}
          />        
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />       
        <Collapse isOpen={isOpen} navbar className="justify-content-center">
            <Nav navbar>
              <NavItem>
                <NavLink href="#hero">About</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#benefit">
                  Benefit
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#term">
                  Syarat & Ketentuan
                </NavLink>
              </NavItem>
              <NavItem className="d-block d-md-none mt-3">
                <a href="#form" className="btn btn-custom" role="button">
                  Daftar Sekarang
                </a>
              </NavItem>                          
            </Nav>
          </Collapse>
            <Nav className="d-none d-md-flex align-items-center" navbar>
              <NavItem>
                  <a className="btn btn-custom" href="#form" role="button">Daftar Sekarang</a>
              </NavItem>          
            </Nav>          
      </Navbar>
    </div>
  );
}

export default NavbarMenu;